import {
  COURSE_STATUS_APPROVED,
  COURSE_STATUS_APPROVED_NAME,
  COURSE_STATUS_PENDING,
  COURSE_STATUS_PENDING_NAME,
  COURSE_STATUS_REJECTED,
  COURSE_STATUS_REJECTED_NAME,
} from 'Constants/General';
import styled from '@emotion/styled';
import { useMemo } from 'react';

const getTextColor = id => {
  switch (id) {
    case COURSE_STATUS_APPROVED:
      return '#FFFFFF';
    case COURSE_STATUS_PENDING:
      return '#000000';
    case COURSE_STATUS_REJECTED:
      return '#FFFFFF';
    default:
      return '#FFFFFF';
  }
};

const getBackgroundColor = id => {
  switch (id) {
    case COURSE_STATUS_APPROVED:
      return '#3F9442';
    case COURSE_STATUS_PENDING:
      return '#FFC107';
    case COURSE_STATUS_REJECTED:
      return '#F44336';
    default:
      return '#9E9E9E';
  }
};

const getBorderColor = id => {
  switch (id) {
    case COURSE_STATUS_APPROVED:
      return '#5BBF5E';
    case COURSE_STATUS_PENDING:
      return '#FFD04492';
    case COURSE_STATUS_REJECTED:
      return '#FF6C61';
    default:
      return '#D2D2D2';
  }
};

const Chip = styled.div`
  position: absolute;
  top: 0.75rem;
  right: 0;
  padding: 0.5rem;
  border-radius: 1rem 0 0 1rem;
  font-weight: bold;

  /* Variantes */
  border: 0.5px solid ${p => getBorderColor(p.id)};
  background-color: ${p => getBackgroundColor(p.id)};
  color: ${p => getTextColor(p.id)};
`;

const CourseStatusChip = ({ id, name }) => {
  const getName = useMemo(() => {
    switch (id) {
      case COURSE_STATUS_APPROVED: {
        return COURSE_STATUS_APPROVED_NAME;
      }
      case COURSE_STATUS_PENDING: {
        return COURSE_STATUS_PENDING_NAME;
      }
      case COURSE_STATUS_REJECTED: {
        return COURSE_STATUS_REJECTED_NAME;
      }
      default:
        return '';
    }
  }, [id]);

  return id ? <Chip id={id}>{name ?? getName}</Chip> : null;
};

export default CourseStatusChip;
